import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconWithTooltip, Text } from 'components/common/Elements/Elements';

import { links } from 'data/constants';

import classes from './HelpCenter.module.scss';

const { helpCenter } = links;

const HelpCenter = () => {
  const { t } = useTranslation('activity');

  return (
    <a
      href={`${helpCenter}/XpLchEEY`}
      target="_blank"
      rel="noreferrer noopener"
      className={classes.link}
    >
      <Text className={classes.visually_hidden}>
        {t('activity:settings.HELP_CENTER')}
      </Text>
      <IconWithTooltip
        icon="helpCenter"
        color="#546491"
        text={t('activity:settings.HELP_CENTER')}
        size="16px"
        className={classes.link_content}
      />
    </a>
  );
};

export default HelpCenter;
